import { action, computed, observable } from 'mobx'
import { ProgressionEditorViewModel } from './ProgressionEditorViewModel'
import { RegularEditorViewModel } from './RegularEditorViewModel'
import {
  type InventoryItemExtensionBillingType,
  type InventoryItemExtensionType,
  type InventoryItemExtensionTypeSpecification,
} from '@/features/inventory/InventoryItem'

export class ExtensionBillingViewModel {
  @observable accessor billingType: InventoryItemExtensionBillingType =
    'FlatFee'

  @observable accessor enableExtensionJobProgressionBillingInfo = false

  /**
   * The type of extension inventory item.
   */
  @observable accessor extensionType: InventoryItemExtensionType = 'Personal'

  readonly regularBillingVm = new RegularEditorViewModel(() => this.billingType)

  readonly progressionBillingVm = new ProgressionEditorViewModel(
    () => this.billingType,
  )

  @computed
  get billingVm() {
    return this.enableExtensionJobProgressionBillingInfo
      ? this.progressionBillingVm
      : this.regularBillingVm
  }

  @action.bound
  setExtensionJobProgressionBillingInfo(enabled: boolean) {
    this.enableExtensionJobProgressionBillingInfo = enabled

    this.billingVm.reset()
  }

  @action.bound
  setExtensionType(extensionType: InventoryItemExtensionType) {
    this.extensionType = extensionType
  }

  @action.bound
  setExtensionBillingType(
    extensionBillingType: InventoryItemExtensionBillingType,
  ) {
    this.billingType = extensionBillingType
  }

  @action.bound
  reset() {
    this.billingType = 'FlatFee'
    this.extensionType = 'Personal'
    this.enableExtensionJobProgressionBillingInfo = false
    this.regularBillingVm.reset()
    this.progressionBillingVm.reset()
  }

  @action.bound
  hydrate(typeSpecification: InventoryItemExtensionTypeSpecification): void {
    this.extensionType = typeSpecification.extensionType
    this.billingType = typeSpecification.billingType
    this.enableExtensionJobProgressionBillingInfo =
      typeSpecification.billingInfo.type === 'Progression'
    this.billingVm.hydrate(typeSpecification.billingInfo)
  }

  validate() {
    return this.enableExtensionJobProgressionBillingInfo
      ? true
      : this.regularBillingVm.validate()
  }
}
